import {
  BanIcon,
  BookOpenIcon,
  BuildingIcon,
  CircleCheckIcon,
  LayersIcon,
  LucideIcon,
  TagIcon,
  ZapIcon,
} from 'lucide-react';

import { ActionType } from '@/shared/types/rules';

export const ACTION_LABEL_KEYS: Record<string, string> = {
  [ActionType.ASSIGN_BRAIN]: 'rules.assign_ai_agent',
  [ActionType.ASSIGN_AI_AGENT]: 'rules.assign_ai_agent',
  [ActionType.ASSIGN_COLLECTION]: 'rules.assign_collection',
  [ActionType.ASSIGN_DEPARTMENT]: 'rules.assign_department',
  [ActionType.APPLY_BUNDLE]: 'rules.apply_bundle',
  [ActionType.ADD_TAG]: 'rules.add_tag',
  [ActionType.CLOSE_CONVERSATION]: 'rules.close_conversation',
  [ActionType.REVOKE_CONSENT]: 'rules.revoke_consent',
};

export const ACTION_ICONS: Record<string, LucideIcon> = {
  [ActionType.ASSIGN_BRAIN]: ZapIcon,
  [ActionType.ASSIGN_AI_AGENT]: ZapIcon,
  [ActionType.ASSIGN_COLLECTION]: BookOpenIcon,
  [ActionType.ASSIGN_DEPARTMENT]: BuildingIcon,
  [ActionType.APPLY_BUNDLE]: LayersIcon,
  [ActionType.ADD_TAG]: TagIcon,
  [ActionType.CLOSE_CONVERSATION]: CircleCheckIcon,
  [ActionType.REVOKE_CONSENT]: BanIcon,
};

export const ACTION_MENU_TYPES = [
  ActionType.ASSIGN_BRAIN,
  ActionType.ASSIGN_COLLECTION,
  ActionType.ASSIGN_DEPARTMENT,
  ActionType.ADD_TAG,
  ActionType.APPLY_BUNDLE,
  ActionType.CLOSE_CONVERSATION,
  ActionType.REVOKE_CONSENT,
];

export const MENU_WRAPPER_CLASS =
  'flex w-auto items-start gap-2 border-none bg-transparent p-0 shadow-none';

export const MENU_PANEL_CLASS =
  'flex max-h-72 w-80 flex-col overflow-hidden rounded-md border border-border bg-background shadow-md';
